module.exports = __webpack_public_path__ + "img/GAME_CARDRIVE.1350242f.png";